import React from 'react';
import { Card, Row, Col, Statistic, Tooltip } from 'antd';
import {
  BugOutlined,
  DesktopOutlined,
  SecurityScanOutlined,
  BarChartOutlined
} from '@ant-design/icons';
import { EstatisticasGerais } from '../../../types/dashboard/csa.types';

interface CSADashboardStatsProps {
  estatisticas: EstatisticasGerais;
  onSeverityClick?: (severity: string) => void;
}

const CSADashboardStats: React.FC<CSADashboardStatsProps> = ({ 
  estatisticas,
  onSeverityClick 
}) => {
  const metricas = [
    {
      title: 'Total de Vulnerabilidades',
      value: estatisticas.totalVulnerabilidades,
      icon: <BugOutlined />,
      color: '#ff4d4f',
      tooltip: 'Vulnerabilidades são falhas de segurança em sistemas, aplicações ou configurações que podem ser exploradas por atacantes para comprometer a segurança da infraestrutura.',
      clickAction: () => {
        if (onSeverityClick) {
          onSeverityClick('clear_all');
        }
      }
    },
    {
      title: 'Hosts Únicos',
      value: estatisticas.hostsUnicos,
      icon: <DesktopOutlined />,
      color: '#1890ff',
      tooltip: 'Hosts são dispositivos conectados à rede (servidores, computadores, equipamentos) que possuem uma ou mais vulnerabilidades identificadas durante a análise CSA.'
    },
    {
      title: 'CVEs Únicas',
      value: estatisticas.cvesUnicas,
      icon: <SecurityScanOutlined />,
      color: '#52c41a',
      tooltip: 'CVE (Common Vulnerabilities and Exposures) é um sistema de identificação padronizado para vulnerabilidades conhecidas publicamente, facilitando o compartilhamento de informações de segurança.'
    },
    {
      title: 'Score Médio CVSS',
      value: estatisticas.scoreMediaCVSS,
      icon: <BarChartOutlined />,
      color: '#faad14',
      tooltip: 'CVSS (Common Vulnerability Scoring System) é um sistema de pontuação que avalia a gravidade das vulnerabilidades numa escala de 0 a 10, onde 10 representa o maior risco.'
    }
  ];

  return (
    <Row gutter={[16, 16]}>
      {metricas.map((metrica, index) => (
        <Col xs={24} sm={12} lg={6} key={index}>
          <Tooltip 
            title={metrica.tooltip}
            placement="top"
            overlayStyle={{ maxWidth: 300 }}
          >
            <Card 
              style={{ 
                cursor: metrica.clickAction ? 'pointer' : 'default',
                transition: 'box-shadow 0.2s'
              }}
              onClick={metrica.clickAction}
              onMouseEnter={(e) => {
                if (metrica.clickAction) {
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
                }
              }}
              onMouseLeave={(e) => {
                if (metrica.clickAction) {
                  e.currentTarget.style.boxShadow = '';
                }
              }}
            >
              <Statistic
                title={metrica.title}
                value={metrica.value}
                valueStyle={{ color: metrica.color }}
                prefix={metrica.icon}
              />
              {metrica.clickAction && (
                <div style={{ 
                  fontSize: '11px', 
                  color: '#8c8c8c', 
                  marginTop: '4px',
                  textAlign: 'center'
                }}>
                </div>
              )}
            </Card>
          </Tooltip>
        </Col>
      ))}
    </Row>
  );
};

export default CSADashboardStats;